<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<h1 class="Heading-1" id="_idParaDest-6"><a id="_idTextAnchor006"></a>Preface</h1>
<p class="Preface-1"><span class="_idGenDropcap-1">L</span><em class="italic">anguage To Live In</em> is my fourth book of poems (preceded by <em class="italic">Simple Rules</em> 1991, 2007; <em class="italic">Erotic Reckonings </em>2012; and <em class="italic">Pied-Piper Philology: Love Words </em>2013). Of the many poems I have written, as well as published, the constant theme is the power—and its obverse, powerlessness—of language. Like any writer born in, and emerging from, the 20th century, I am constantly reminded of the powerlessness of language, a practically obsessional theme of poets in the European and American traditions during that century of holocausts. But, I also feel and celebrate in my poems the power of language, and I give equal emphasis to both, or at least I try to do so. My one aspiration in all my poems is to use adequate language adequately: language adequate to the imperatives of imagination, used with skill adequate to the demands of form. If readers should feel that I have succeeded even once or twice in fulfilling this aspiration, then the lifetime of writing I have lived will have been worth the effort—‘To Him of adequate desire / No further ’tis, than here’ (Emily Dickinson <em class="italic">370</em>).</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781645367314_EPUB-6.vue?5eb2d69c